import { createContext } from 'react';
import { DataFetchingThunkAction, BellaThunkDispatch } from '../../redux/types';

export interface FetchActionManager {
    dispatchFetchingAction: (thunkAction: DataFetchingThunkAction, dispatch: BellaThunkDispatch) => void;
    executeAsyncAction: (executor: () => PromiseLike<void>) => void;
}

export const FetchManagerContext = createContext<FetchActionManager>({} as any);

export const FetchManagerProvider = FetchManagerContext.Provider;
export const FetchManagerConsumer = FetchManagerContext.Consumer;
